<p-menubar [model]="menus" styleClass="iam-menu {{decreeCircular === 'DecCir78' ? 'menu-78' : ''}}"></p-menubar>
